import { useMemo } from "react";
import { useIntl } from "react-intl";

export function useIntlTokens() {
  const intl = useIntl();
  return useMemo(
    () => ({
      All: intl.formatMessage({
        defaultMessage: "All",
        description: "intl_token All",
      }),
      Odd: intl.formatMessage({
        defaultMessage: "Odd",
        description: "intl_token Odd",
      }),
      Even: intl.formatMessage({
        defaultMessage: "Even",
        description: "intl_token Even",
      }),
      GetStarted: intl.formatMessage({
        defaultMessage: "Get started",
        description: "intl_token Get started",
      }),
      SubscriptionLink: intl.formatMessage({
        defaultMessage: "Subscription Link",
        description: "intl_token Subscription Link",
      }),
      SubscribeToCalendar: intl.formatMessage({
        defaultMessage: "Subscribe to Calendar",
        description: "intl_token Subscribe to Calendar",
      }),
      SelectCalendars: intl.formatMessage({
        defaultMessage: "Select Calendars",
        description: "intl_token Select Calendars",
      }),
      Starts: intl.formatMessage({
        defaultMessage: "Starts",
        description: "intl_token Starts",
      }),
      Ends: intl.formatMessage({
        defaultMessage: "Ends",
        description: "intl_token Ends",
      }),
      Calendar: intl.formatMessage({
        defaultMessage: "Calendar",
        description: "intl_token Calendar",
      }),
      Calendars: intl.formatMessage({
        defaultMessage: "Calendars",
        description: "intl_token Calendars",
      }),
      AllDay: intl.formatMessage({
        defaultMessage: "All-day",
        description: "intl_token All-day",
      }),
      AddCalendar: intl.formatMessage({
        defaultMessage: "Add Calendar",
        description: "intl_token Add Calendar",
      }),
      ArchivedCalendars: intl.formatMessage({
        defaultMessage: "Archived Calendars",
        description: "intl_token Archived Calendars",
      }),
      CreateCalendar: intl.formatMessage({
        defaultMessage: "Create Calendar",
        description: "intl_token Create Calendar",
      }),
      AddCalendarEvent: intl.formatMessage({
        defaultMessage: "Add Event",
        description: "intl_token Create Calendar Event",
      }),
      EditCalendarEvent: intl.formatMessage({
        defaultMessage: "Edit Event",
        description: "intl_token Edit Calendar Event",
      }),
      CalendarEvent: intl.formatMessage({
        defaultMessage: "Event",
        description: "intl_token Calendar Event",
      }),
      EditCalendar: intl.formatMessage({
        defaultMessage: "Edit Calendar",
        description: "intl_token Edit Calendar",
      }),
      Absence: intl.formatMessage({
        defaultMessage: "Absence",
        description: "intl_token Absence",
      }),
      AllReasons: intl.formatMessage({
        defaultMessage: "All reasons",
        description: "intl_token All reasons",
      }),
      ReasonsForAbsence: intl.formatMessage({
        defaultMessage: "Reasons for absence",
        description: "intl_token Reasons for absence",
      }),
      ArchiveNow: intl.formatMessage({
        defaultMessage: "Archive Now",
        description: "intl_token Archive Now",
      }),
      Optional: intl.formatMessage({
        defaultMessage: "Optional",
        description: "intl_token Optional",
      }),
      ScheduleArchive: intl.formatMessage({
        defaultMessage: "Schedule Archive",
        description: "intl_token Schedule Archive",
      }),
      UsersAndDevices: intl.formatMessage({
        defaultMessage: "Users and Devices",
        description: "StoreAdmin:Item label users and devices",
      }),
      AllUnitsAndTeams: intl.formatMessage({
        defaultMessage: "All Units & Teams",
        description: "intl_token All Stores & Teams",
      }),
      Admins: intl.formatMessage({
        defaultMessage: "Admins",
        description: "intl_token Admins",
      }),
      LockedTopic: intl.formatMessage({
        defaultMessage: "Locked Topic",
        description: "intl_token LockedTopic",
      }),
      LockedTeam: intl.formatMessage({
        defaultMessage: "Locked Team",
        description: "intl_token Locked Team",
      }),
      AssignPermissions: intl.formatMessage({
        defaultMessage: "Assign Permissions",
        description: "intl_token Assign Permissions",
      }),
      AssignScheduleTypes: intl.formatMessage({
        defaultMessage: "Assign Cost Centers",
        description: "intl_token Assign Schedule Types",
      }),
      Topics: intl.formatMessage({
        defaultMessage: "Routing",
        description: "intl_token Topics",
      }),
      Topic: intl.formatMessage({
        defaultMessage: "Attribute",
        description: "intl_token Topic",
      }),
      EmployeeSchedule: intl.formatMessage({
        defaultMessage: "Schedule",
        description: "intl_token Employee Schedule",
      }),
      SelectStore: intl.formatMessage({
        defaultMessage: "Select Unit",
        description: "UserProfile:SelectStoreScreen: header title",
      }),
      CreateEmployee: intl.formatMessage({
        defaultMessage: "Create Employee",
        description: "intl_token Create Employee",
      }),
      DeleteEmployee: intl.formatMessage({
        defaultMessage: "Delete Employee",
        description: "intl_token Delete Employee",
      }),
      AddEmployee: intl.formatMessage({
        defaultMessage: "Add Employee",
        description: "intl_token Add Employee",
      }),
      SubTodos: intl.formatMessage({
        defaultMessage: "Sub-todos",
        description: "intl_token SubTodos",
      }),
      Routines: intl.formatMessage({
        defaultMessage: "Routines",
        description: "intl_token Routines",
      }),
      Analytics: intl.formatMessage({
        defaultMessage: "Analytics",
        description: "intl_token Analytics",
      }),
      ReadOnly: intl.formatMessage({
        defaultMessage: "Read Only",
        description: "intl_token Read Only",
      }),
      CreateNewTemplate: intl.formatMessage({
        defaultMessage: "Create new Template",
        description: "intl_token Create new template",
      }),
      UpdateTemplate: intl.formatMessage({
        defaultMessage: "Update Template",
        description: "intl_token Update Template",
      }),
      DeleteTemplate: intl.formatMessage({
        defaultMessage: "Delete Template",
        description: "intl_token Delete Template",
      }),
      ApplyTemplate: intl.formatMessage({
        defaultMessage: "Apply Template",
        description: "intl_token Apply Template",
      }),
      AddSharedDevice: intl.formatMessage({
        defaultMessage: "Add Shared Device",
        description: "intl_token Add Shared Device",
      }),
      ResendInvite: intl.formatMessage({
        defaultMessage: "Resend Invite",
        description: "intl_token Resend Invite",
      }),
      InviteExpired: intl.formatMessage({
        defaultMessage: "Invite Expired",
        description: "intl_token Invite Expired",
      }),
      InviteSent: intl.formatMessage({
        defaultMessage: "Invite Sent",
        description: "intl_token Invite Sent",
      }),
      InvitePending: intl.formatMessage({
        defaultMessage: "Invite Pending",
        description: "intl_token Invite Pending",
      }),
      ConnectEmployee: intl.formatMessage({
        defaultMessage: "Connect Employee",
        description: "intl_token Connect Employee",
      }),
      CreateGroupAccount: intl.formatMessage({
        defaultMessage: "Create Group Account",
        description: "intl_token Create Group Account",
      }),
      CreatePersonalAccount: intl.formatMessage({
        defaultMessage: "Create Personal Account",
        description: "intl_token Create Personal Account",
      }),
      GroupAccount: intl.formatMessage({
        defaultMessage: "Group Account",
        description: "intl_token Group Account",
      }),
      PersonalAccount: intl.formatMessage({
        defaultMessage: "Personal Account",
        description: "intl_token Personal Account",
      }),
      DeleteAccount: intl.formatMessage({
        defaultMessage: "Delete Account",
        description: "intl_token Delete Account",
      }),
      Role: intl.formatMessage({
        defaultMessage: "Role",
        description: "intl_token Role",
      }),
      Roles: intl.formatMessage({
        defaultMessage: "Roles",
        description: "intl_token Roles",
      }),
      WithoutRole: intl.formatMessage({
        defaultMessage: "Without role",
        description: "intl_token Without role",
      }),
      Permissions: intl.formatMessage({
        defaultMessage: "Permissions",
        description: "intl_token Permissions",
      }),
      Lineup: intl.formatMessage({
        defaultMessage: "Lineup",
        description: "intl_token Lineup",
      }),
      EditLineup: intl.formatMessage({
        defaultMessage: "Edit Lineup",
        description: "intl_token Edit Lineup",
      }),
      EditRole: intl.formatMessage({
        defaultMessage: "Edit Role",
        description: "intl_token Edit Role",
      }),
      Account: intl.formatMessage({
        defaultMessage: "Account",
        description: "intl_token Account",
      }),
      Employees: intl.formatMessage({
        defaultMessage: "Employees",
        description: "intl_token Employees",
      }),
      Employee: intl.formatMessage({
        defaultMessage: "Employee",
        description: "intl_token Employee",
      }),
      Guest: intl.formatMessage({
        defaultMessage: "Guest",
        description: "intl_token Guest",
      }),
      CentralisedChecklists: intl.formatMessage({
        defaultMessage: "Centralised Checklists",
        description: "intl_token Centralised Checklists",
      }),
      RoutineLibrary: intl.formatMessage({
        defaultMessage: "Routine Library",
        description: "intl_token Routine Library",
      }),
      Invite: intl.formatMessage({
        defaultMessage: "Invite",
        description: "intl_token Invite",
      }),
      Duplicate: intl.formatMessage({
        defaultMessage: "Duplicate",
        description: "intl_token Duplicate",
      }),
      ChangeExpireDate: intl.formatMessage({
        defaultMessage: "Change Expire Date",
        description: "intl_token Change Expire Date",
      }),
      DeleteExpireDate: intl.formatMessage({
        defaultMessage: "Delete Expire Date",
        description: "intl_token Delete Expire Date",
      }),
      ExpireDate: intl.formatMessage({
        defaultMessage: "Expire Date",
        description: "intl_token Expire Date",
      }),
      ExpireDates: intl.formatMessage({
        defaultMessage: "Expire Dates",
        description: "intl_token Expire Dates",
      }),
      Templates: intl.formatMessage({
        defaultMessage: "Templates",
        description: "intl_token Templates",
      }),
      Update: intl.formatMessage({
        defaultMessage: "Update",
        description: "intl_token Update",
      }),
      Replace: intl.formatMessage({
        defaultMessage: "Replace",
        description: "intl_token Replace",
      }),
      Linked: intl.formatMessage({
        defaultMessage: "Linked",
        description: "intl_token Linked",
      }),
      Primary: intl.formatMessage({
        defaultMessage: "Primary",
        description: "intl_token Primary",
      }),
      ShowArchived: intl.formatMessage({
        defaultMessage: "Show archived",
        description: "intl_token Show archived",
      }),
      Never: intl.formatMessage({
        defaultMessage: "Never",
        description: "intl_token Never",
      }),
      Unread: intl.formatMessage({
        defaultMessage: "Unread",
        description: "intl_token Unread",
      }),
      Opened: intl.formatMessage({
        defaultMessage: "Opened",
        description: "intl_token Opened",
      }),
      General: intl.formatMessage({
        defaultMessage: "General",
        description: "intl_token General",
      }),
      CustomiseYourWidget: intl.formatMessage({
        defaultMessage: "Customise your widget",
        description: "intl_token Customise your widget",
      }),
      CustomListAdmin: intl.formatMessage({
        defaultMessage: "Custom List Admin",
        description: "intl_token Custom List Admin",
      }),
      ChooseList: intl.formatMessage({
        defaultMessage: "Choose List",
        description: "intl_token Choose List",
      }),
      ListName: intl.formatMessage({
        defaultMessage: "List Name",
        description: "intl_token List Name",
      }),
      CreateCustomList: intl.formatMessage({
        defaultMessage: "Create Custom List",
        description: "intl_token Create Custom List",
      }),
      CustomLists: intl.formatMessage({
        defaultMessage: "Custom Lists",
        description: "intl_token",
      }),
      Title: intl.formatMessage({
        defaultMessage: "Title",
        description: "intl_token Title",
      }),
      Time: intl.formatMessage({
        defaultMessage: "Time",
        description: "intl_token Time",
      }),
      Clear: intl.formatMessage({
        defaultMessage: "Clear",
        description: "intl_token Clear",
      }),
      Assign: intl.formatMessage({
        defaultMessage: "Assign",
        description: "intl_token Assign",
      }),
      Assignees: intl.formatMessage({
        defaultMessage: "Assignees",
        description: "intl_token Assignees",
      }),
      Date: intl.formatMessage({
        defaultMessage: "Date",
        description: "intl_tokens Date",
      }),
      Tags: intl.formatMessage({
        defaultMessage: "Tags",
        description: "intl_token Tags",
      }),
      Published: intl.formatMessage({
        defaultMessage: "Published",
        description: "intl_token",
      }),
      Status: intl.formatMessage({
        defaultMessage: "Status",
        description: "intl_token Status",
      }),
      Deadline: intl.formatMessage({
        defaultMessage: "Deadline",
        description: "intl_token Description",
      }),
      Prio: intl.formatMessage({
        defaultMessage: "Prio",
        description: "intl_token Prio",
      }),
      Priority: intl.formatMessage({
        defaultMessage: "Priority",
        description: "intl_token Priority",
      }),
      Publish: intl.formatMessage({
        defaultMessage: "Publish",
        description: "intl_token Publish",
      }),
      Upload: intl.formatMessage({
        defaultMessage: "Upload",
        description: "intl_token Upload",
      }),
      Spaces: intl.formatMessage({
        defaultMessage: "Spaces",
        description: "intl_token Spaces",
      }),
      Space: intl.formatMessage({
        defaultMessage: "Space",
        description: "intl_token Space",
      }),
      New: intl.formatMessage({
        defaultMessage: "New",
        description: "intl_token New",
      }),
      DashboardSettings: intl.formatMessage({
        defaultMessage: "Dashboard Settings",
        description: "intl_token Dashboard Settings",
      }),
      Dashboards: intl.formatMessage({
        defaultMessage: "Dashboards",
        description: "intl_token Dashboards",
      }),
      Admin: intl.formatMessage({
        defaultMessage: "Admin",
        description: "intl_token Admin",
      }),
      ArchivedTeams: intl.formatMessage({
        defaultMessage: "Archived Teams",
        description: "intl_token Archived Teams",
      }),
      CreateTeam: intl.formatMessage({
        defaultMessage: "Create Team",
        description: "intl_token Create Team",
      }),
      Unarchive: intl.formatMessage({
        defaultMessage: "Unarchive",
        description: "intl_token Unarchive",
      }),
      Archive: intl.formatMessage({
        defaultMessage: "Archive",
        description: "intl_token Archive",
      }),
      Archived: intl.formatMessage({
        defaultMessage: "Archived",
        description: "intl_token Archived",
      }),
      AddProduct: intl.formatMessage({
        defaultMessage: "Add Product",
        description: "intl_token Add Product",
      }),
      Activate: intl.formatMessage({
        defaultMessage: "Activate",
        description: "intl_token Activate",
      }),
      DeleteUser: intl.formatMessage({
        defaultMessage: "Delete User",
        description: "intl_token Delete User",
      }),
      Email: intl.formatMessage({
        defaultMessage: "Email",
        description: "intl_token Email",
      }),
      User: intl.formatMessage({
        defaultMessage: "User",
        description: "intl_token User",
      }),
      Users: intl.formatMessage({
        defaultMessage: "Users",
        description: "intl_token Users",
      }),
      InviteUser: intl.formatMessage({
        defaultMessage: "Invite User",
        description: "intl_token Invite User",
      }),
      WorkspaceAdmin: intl.formatMessage({
        defaultMessage: "Workspace Admin",
        description: "intl_token Workspace Admin",
      }),
      OrgAdmin: intl.formatMessage({
        defaultMessage: "Org Admin",
        description: "intl_token Org Admin",
      }),
      HQInfo: intl.formatMessage({
        defaultMessage: "HQ Info",
        description: "intl_token HQ Info",
      }),
      LogOut: intl.formatMessage({
        defaultMessage: "Log Out",
        description: "intl_token Log Out",
      }),

      Widgets: intl.formatMessage({
        defaultMessage: "Widgets",
        description: "intl_token Widgets",
      }),

      Units: intl.formatMessage({
        defaultMessage: "Units",
        description: "intl_token Units",
      }),
      CreateUnit: intl.formatMessage({
        defaultMessage: "Create Unit",
        description: "intl_token Create Unit",
      }),
      CreateWorkspace: intl.formatMessage({
        defaultMessage: "Create Workspace",
        description: "intl_token Create Workspace",
      }),
      CreateNote: intl.formatMessage({
        defaultMessage: "Create Note",
        description: "intl_token Add Note",
      }),

      StoreAdmin: intl.formatMessage({
        defaultMessage: "Store Admin",
        description: "intl_token StoreAdmin",
      }),
      TeamAdmin: intl.formatMessage({
        defaultMessage: "Team Admin",
        description: "intl_token TeamAdmin",
      }),
      Issue: intl.formatMessage({
        defaultMessage: "Issue",
        description: "intl_token Issue",
      }),
      MonthlyRoutines: intl.formatMessage({
        defaultMessage: "Monthly Routines",
        description: "intl_token Monthly Routines",
      }),
      WeeklyRoutines: intl.formatMessage({
        defaultMessage: "Weekly Routines",
        description: "intl_token Weekly Routines",
      }),
      DailyRoutines: intl.formatMessage({
        defaultMessage: "Daily Routines",
        description: "intl_token Daily Routines",
      }),
      OK: intl.formatMessage({
        defaultMessage: "OK",
        description: "intl_token OK",
      }),
      Hidden: intl.formatMessage({
        defaultMessage: "Hidden",
        description: "intl_token Hidden",
      }),
      EditKPI: intl.formatMessage({
        defaultMessage: "Edit KPI",
        description: "intl_token Edit KPI",
      }),
      DeleteKPI: intl.formatMessage({
        defaultMessage: "Delete KPI",
        description: "intl_token Delete KPI",
      }),
      EnterThisWeeksValue: intl.formatMessage({
        defaultMessage: "Enter this week's value",
        description: "intl_token Enter this week's value",
      }),
      EnterLastWeeksValue: intl.formatMessage({
        defaultMessage: "Enter last week's value",
        description: "intl_token Enter last week's value",
      }),
      EnterTodaysValue: intl.formatMessage({
        defaultMessage: "Enter today’s value",
        description: "intl_token Enter today’s value",
      }),
      EnterYesterdaysValue: intl.formatMessage({
        defaultMessage: "Enter yesterday’s value",
        description: "intl_token Enter yesterday’s value",
      }),
      AddMeasurmentArea: intl.formatMessage({
        defaultMessage: "Add measurement area",
        description: "intl_token Add measurement area",
      }),
      SetTargets: intl.formatMessage({
        defaultMessage: "Set target",
        description: "intl_token Set target",
      }),
      ActivateTargets: intl.formatMessage({
        defaultMessage: "Activate target",
        description: "intl_token Activate target",
      }),
      More: intl.formatMessage({
        defaultMessage: "More",
        description: "intl_token More",
      }),
      MoreThan: intl.formatMessage({
        defaultMessage: "More than",
        description: "intl_token More than",
      }),
      LessThan: intl.formatMessage({
        defaultMessage: "Less than",
        description: "intl_oktne Less than",
      }),

      Name: intl.formatMessage({
        defaultMessage: "Name",
        description: "intl_token Name",
      }),
      AllSections: intl.formatMessage({
        defaultMessage: "All Sections",
        description: "intl_token All Sections",
      }),
      AddMesurementAreas: intl.formatMessage({
        defaultMessage: "Add Measurement Areas",
        description: "intl_token Add Measurement Areas",
      }),
      AllMesurementAreas: intl.formatMessage({
        defaultMessage: "All Measurement Areas",
        description: "intl_token All Measurement Areas",
      }),
      SelectMeasurementAreas: intl.formatMessage({
        defaultMessage: "Select Measurement Areas",
        description: "intl_token Select Measurement Areas",
      }),
      MeasurementAreas: intl.formatMessage({
        defaultMessage: "Measurement Areas",
        description: "intl_token Measurement Areas",
      }),
      CurrentIssues: intl.formatMessage({
        defaultMessage: "Current Issues",
        description: "intl_token Current Issues",
      }),
      NotEnoughSpace: intl.formatMessage({
        defaultMessage: "Not Enough Space",
        description: "intl_token Not Enough Space",
      }),
      AdminKPI: intl.formatMessage({
        defaultMessage: "Admin KPIs",
        description: "intl_token Admin KPI",
      }),
      AdminChecklists: intl.formatMessage({
        defaultMessage: "Admin Checklists",
        description: "intl_token Admin Checklists",
      }),
      Todos: intl.formatMessage({
        defaultMessage: "Todos",
        description: "intl_token Todos",
      }),
      Signals: intl.formatMessage({
        defaultMessage: "Signals",
        description: "intl_token Signals",
      }),
      Empty: intl.formatMessage({
        defaultMessage: "Empty",
        description: "intl_token Empty",
      }),
      Preview: intl.formatMessage({
        defaultMessage: "Preview",
        description: "intl_token Preview",
      }),
      SetTitle: intl.formatMessage({
        defaultMessage: "Set Title",
        description: "intl_token Set Title",
      }),
      AddWidget: intl.formatMessage({
        defaultMessage: "Add Widget",
        description: "intl_token Add Widget",
      }),
      Select: intl.formatMessage({
        defaultMessage: "Select",
        description: "intl_token Select",
      }),
      Selected: intl.formatMessage({
        defaultMessage: "Selected",
        description: "intl_token selected",
      }),
      SelectSections: intl.formatMessage({
        defaultMessage: "Select Sections",
        description: "intl_token Select Sections",
      }),
      Search: intl.formatMessage({
        defaultMessage: "Search",
        description: "intl_token Search",
      }),
      AddTasks: intl.formatMessage({
        defaultMessage: "Add tasks",
        description: "intl_token Add Tasks",
      }),
      Integration: intl.formatMessage({
        defaultMessage: "Integration",
        description: "intl_token Integration",
      }),
      AddIntegration: intl.formatMessage({
        defaultMessage: "Add Integration",
        description: "intl_token Add Integration",
      }),
      AddIntegrations: intl.formatMessage({
        defaultMessage: "Add Integrations",
        description: "intl_token Add Integrations",
      }),
      SelectTeam: intl.formatMessage({
        defaultMessage: "Select Team",
        description: "intl_token Select Team",
      }),
      SelectTeams: intl.formatMessage({
        defaultMessage: "Select Teams",
        description: "intl_token Select Teams",
      }),
      SelectChecklists: intl.formatMessage({
        defaultMessage: "Select Checklists",
        description: "intl_token Select Checklists",
      }),
      SelectTask: intl.formatMessage({
        defaultMessage: "Select Task",
        description: "intl_token Select Task",
      }),
      SelectTasks: intl.formatMessage({
        defaultMessage: "Select Tasks",
        description: "intl_token Select Tasks",
      }),
      SelectLocation: intl.formatMessage({
        defaultMessage: "Select Location",
        description: "inlt_token Select Location",
      }),
      Location: intl.formatMessage({
        defaultMessage: "Location",
        description: "intl_token Location",
      }),
      Note: intl.formatMessage({
        defaultMessage: "Note",
        description: "intl_token Note",
      }),
      Weather: intl.formatMessage({
        defaultMessage: "Weather",
        description: "intl_token Weather",
      }),
      Suggestions: intl.formatMessage({
        defaultMessage: "Suggestions",
        description: "intl_token Suggestions",
      }),
      TeamSchedules: intl.formatMessage({
        defaultMessage: "Team Schedules",
        description: "intl_token Team Schedules",
      }),
      Integrations: intl.formatMessage({
        defaultMessage: "Integrations",
        description: "intl_token Integrations",
      }),
      End: intl.formatMessage({
        defaultMessage: "End",
        description: "intl_token End",
      }),
      Products: intl.formatMessage({
        defaultMessage: "Products",
        description: "intl_token Products",
      }),
      PLU: intl.formatMessage({
        defaultMessage: "PLU",
        description: "intl_token PLU",
      }),
      Weekly: intl.formatMessage({
        defaultMessage: "Weekly",
        description: "intl_token Weekly",
      }),
      Week: intl.formatMessage({
        defaultMessage: "Week",
        description: "intl_token Week",
      }),
      Daily: intl.formatMessage({
        defaultMessage: "Daily",
        description: "intl_token Daily",
      }),
      EveryDay: intl.formatMessage({
        defaultMessage: "Every day",
        description: "intl_token EveryDay",
      }),
      Weekends: intl.formatMessage({
        defaultMessage: "Weekends",
        description: "intl_token Weekends",
      }),
      Weekdays_excluding_weekend: intl.formatMessage({
        defaultMessage: "Weekdays",
        description: "intl_token Weekdays excluding weekend",
      }),
      Weekdays_including_weekend: intl.formatMessage({
        defaultMessage: "Weekdays",
        description: "intl_token Weekdays including weekend",
      }),
      Checklists: intl.formatMessage({
        defaultMessage: "Checklists",
        description: "intl_token Checklists",
      }),
      ChecklistsTemplates: intl.formatMessage({
        defaultMessage: "Templates",
        description: "intl_token Checklists Templates",
      }),
      Checklist: intl.formatMessage({
        defaultMessage: "Checklist",
        description: "intl_token Checklist",
      }),
      CreateChecklist: intl.formatMessage({
        defaultMessage: "Create Checklist",
        description: "intl_tokens Create Checklist",
      }),
      DeleteChecklist: intl.formatMessage({
        defaultMessage: "Delete Checklist",
        description: "intl_token Delete Checklist",
      }),
      Home: intl.formatMessage({
        defaultMessage: "Home",
        description: "intl_token Home",
      }),
      TeamSchedule: intl.formatMessage({
        defaultMessage: "Team Schedule",
        description: "intl_token Team Schedule",
      }),
      Target: intl.formatMessage({
        defaultMessage: "Target",
        description: "intl_token Target",
      }),
      Under: intl.formatMessage({
        defaultMessage: "Under",
        description: "intl_token Under",
      }),
      Over: intl.formatMessage({
        defaultMessage: "Over",
        description: "intl_token Over",
      }),
      Total: intl.formatMessage({
        defaultMessage: "Total",
        description: "intl_token Total",
      }),
      Avg: intl.formatMessage({
        defaultMessage: "Avg",
        description: "intl_token Avg",
      }),
      Help: intl.formatMessage({
        defaultMessage: "Help",
        description: "intl_token Help",
      }),
      Unit: intl.formatMessage({
        defaultMessage: "Unit",
        description: "intl_token Unit",
      }),
      Other: intl.formatMessage({
        defaultMessage: "Other",
        description: "intl_token Other",
      }),
      Currency: intl.formatMessage({
        defaultMessage: "Currency",
        description: "intl_token Currency",
      }),
      Category: intl.formatMessage({
        defaultMessage: "Category",
        description: "intl_token Category",
      }),
      Categories: intl.formatMessage({
        defaultMessage: "Categories",
        description: "intl_token Cattegories",
      }),
      Color: intl.formatMessage({
        defaultMessage: "Color",
        description: "intl_token Color",
      }),
      Now: intl.formatMessage({
        defaultMessage: "Now",
        description: "intl_token Now",
      }),
      Soon: intl.formatMessage({
        defaultMessage: "Soon",
        description: "intl_tokens Soon",
      }),
      SeeMore: intl.formatMessage({
        defaultMessage: "See more",
        description: "intl_token See More",
      }),
      Remove: intl.formatMessage({
        defaultMessage: "Remove",
        description: "intl_token Remove",
      }),
      Description: intl.formatMessage({
        defaultMessage: "Description",
        description: "intl_token Description",
      }),
      Skip: intl.formatMessage({
        defaultMessage: "Skip",
        description: "intl_token Skip",
      }),
      KPIs: intl.formatMessage({
        defaultMessage: "KPIs",
        description: "intl_token KPIs",
      }),
      Storecast: intl.formatMessage({
        defaultMessage: "Storecast",
        description: "intl_token Storecast",
      }),
      Issues: intl.formatMessage({
        defaultMessage: "Issues",
        description: "intl_token Issues",
      }),
      AllIssues: intl.formatMessage({
        defaultMessage: "Issues",
        description: "intl_token AllIssues",
      }),
      AllFiles: intl.formatMessage({
        defaultMessage: "All Files",
        description: "intl_token AllFiles",
      }),
      Files: intl.formatMessage({
        defaultMessage: "Files",
        description: "intl_token Files",
      }),
      SearchUsers: intl.formatMessage({
        defaultMessage: "Search Users",
        description: "intl_token Search Users",
      }),
      SearchProducts: intl.formatMessage({
        defaultMessage: "Search Products",
        description: "intl_token Search Products",
      }),
      TipTitle: intl.formatMessage({
        defaultMessage: "Tip!",
        description: "intl_token TipTitle",
      }),
      Task: intl.formatMessage({
        defaultMessage: "Task",
        description: "intl_token Task",
      }),
      Tasks: intl.formatMessage({
        defaultMessage: "Tasks",
        description: "intl_tokens Tasks",
      }),
      FocusMode: intl.formatMessage({
        defaultMessage: "Focus Mode",
        description: "intl_token Focus Mode",
      }),
      Previous: intl.formatMessage({
        defaultMessage: "Previous",
        description: "intl_token previous",
      }),
      Back: intl.formatMessage({
        defaultMessage: "Back",
        description: "intl_token back",
      }),
      Cancel: intl.formatMessage({
        defaultMessage: "Cancel",
        description: "intl_token cancel",
      }),
      Next: intl.formatMessage({
        defaultMessage: "Next",
        description: "intl_token next",
      }),
      Done: intl.formatMessage({
        defaultMessage: "Done",
        description: "intl_token done",
      }),
      Delete: intl.formatMessage({
        defaultMessage: "Delete",
        description: "intl_token delete",
      }),
      Save: intl.formatMessage({
        defaultMessage: "Save",
        description: "intl_token save",
      }),
      Change: intl.formatMessage({
        defaultMessage: "Change",
        description: "intl_token change",
      }),
      Create: intl.formatMessage({
        defaultMessage: "Create",
        description: "intl_token create",
      }),
      Created: intl.formatMessage({
        defaultMessage: "Created",
        description: "intl_token created",
      }),
      Resolved: intl.formatMessage({
        defaultMessage: "Resolved",
        description: "intl_token resolved",
      }),
      Registered: intl.formatMessage({
        defaultMessage: "Registered",
        description: "intl_token registered",
      }),
      Completed: intl.formatMessage({
        defaultMessage: "Completed",
        description: "intl_token completed",
      }),

      Close: intl.formatMessage({
        defaultMessage: "Close",
        description: "intl_token close",
      }),
      Edit: intl.formatMessage({
        defaultMessage: "Edit",
        description: "intl_token edit",
      }),
      Add: intl.formatMessage({
        defaultMessage: "Add",
        description: "intl_token add",
      }),
      Teams: intl.formatMessage({
        defaultMessage: "Teams",
        description: "intl_token teams",
      }),
      Devices: intl.formatMessage({
        defaultMessage: "Devices",
        description: "intl_token Devices",
      }),
      Screens: intl.formatMessage({
        defaultMessage: "Screens",
        description: "intl_token Screens",
      }),
      SharedDevices: intl.formatMessage({
        defaultMessage: "Shared Devices",
        description: "intl_token Shared Devices",
      }),
      LastSeen: intl.formatMessage({
        defaultMessage: "Last seen",
        description: "intl_token Last seen",
      }),
      LastIP: intl.formatMessage({
        defaultMessage: "Last IP",
        description: "intl_token Last IP",
      }),
      AllTeams: intl.formatMessage({
        defaultMessage: "All Teams",
        description: "intl_token All Teams",
      }),
      Team: intl.formatMessage({
        defaultMessage: "Team",
        description: "intl_token team",
      }),
      RoutineSections: intl.formatMessage({
        defaultMessage: "Sections",
        description: "intl_token routine sections",
      }),
      LearnMore: intl.formatMessage({
        defaultMessage: "Learn More",
        description: "intl_token learn more",
      }),
      Export: intl.formatMessage({
        defaultMessage: "Export",
        description: "intl_token Export",
      }),
    }),
    [intl]
  );
}
